import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ModalNouveauGroupe from './modal/ModalNouveauGroupe';

const ip = process.env.REACT_APP_IP;

const GroupeSelector = ({ selectedGroupe, setSelectedGroupe, modif, token }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [groupList, setGroupList] = useState(null); // Initialize as null

    const fetchGroups = async () => {
        try {
            const response = await axios.get(`${ip}/groups`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });
            setGroupList(response.data || []); // Set to empty array if response is null or undefined
        } catch (error) {
            console.error('Erreur lors de la requête get :', error);
            setGroupList([]); // Set to empty array on error to avoid infinite loading
        }
    };

    const handleSelectGroup = (e) => {
        const selectedValue = e.target.value;
        if (selectedValue === "-1") {
            setIsModalOpen(true);
        } else {
            setSelectedGroupe(selectedValue);
        }
    };

    useEffect(() => {
        fetchGroups();
    }, []);

    if (groupList === null) {
        return <div>Chargement groupe en cours...</div>;
    }

    return (
        <React.Fragment>
            <select className='margin_1em input-transparent' value={selectedGroupe} onChange={handleSelectGroup}>
                <option value={0}>{modif ? "Pas d'Ajout" : "Non-Affilié"}</option>
                {groupList.map((groupe) => (
                    <option key={groupe.idGroupe} value={groupe.idGroupe}>
                        {groupe.nom}
                    </option>
                ))}
                <option value={-1}>+</option>
            </select>
            <ModalNouveauGroupe
                isOpen={isModalOpen}
                setOpen={setIsModalOpen}
                fetchGroups={fetchGroups}
                setSelectedGroupe={setSelectedGroupe}
                token={token}
            />
        </React.Fragment>
    );
};

export default GroupeSelector;
